"use strict";

/**
* Объект верхней части проводника.
*
* @class WebAccess.components.Header
* @extends BaseObject
* @property {string} _containerID - ID элемента DOM, в котором рендерится react-компонента шапки
* @property {object} _model - Модель шапки проводника
*/

(function (global) {
  var Header = BaseObject.extend({

    _containerId: "",
    _model: {},
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Конструктор
     * @param {string} containerId - ИД элемента страницы, в который будет помещен сгенерированный HTML-элемент верхней части проводника
     * @param {object} model - Модель верхней части проводника
     * @param {array} childObjects - Массив объектов в верхней части проводника, которыми можно управлять через клиентский API веб-доступа
     * @method WebAccess.components.Header#init
     */
    init: function (containerId, model, childObjects) {
      var me = this;
      me._containerId = containerId;
      me._model = model;
      childObjects.forEach(function(object) {
        object.bind(object['class'].EVENT.CHANGE_STATE, function () {
          me._render();
        });
      });
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Отрендерить компоненту ExplorerHeader с помощью react.
     */
    _render: function () {
      var me = this;
      ReactDOM.render(
        React.createElement(Component.ExplorerHeader, me._model),
        document.getElementById(me._containerId)
      );
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  });

  global.Header = Header;

})(window.WebAccess.components);
